import Cookies from "js-cookie";

import { ACCESS_TOKEN_KEY, COOKIES_COMPANY_ID } from "../utils/constants";
import {
  fakeAPIRequest,
  mapApiBidToModel,
  mapApiToLaneModel,
  normalizeSearchTerms,
} from "../utils/helper";
import { setAuthHeader, apiService } from "./api";
import { CACHED, fetchUserCompanies, invalidate } from "../shared/session";
import { AirportData, Lane } from "../models/lane";
import { NotificationItems } from "../models/Bid";

export async function fetchNotificationCount() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  await fakeAPIRequest(companyId!);

  return {
    data: {
      bidIDs: [
        { bidID: "1", companyID: "N0001" },
        { bidID: "2", companyID: "N0001" },
        { bidID: "3", companyID: "N0001" },
      ],
    },
  };

  // const response = await apiService.get(
  //   `/company/${companyId}/bids/notifications`
  // );

  // return response.data;
}

export async function readNotifications({ bidIDs }: { bidIDs: any[] }) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  await fakeAPIRequest(companyId!);

  // const response = await apiService.post(
  //   `/company/${companyId}/bids/notifications/read`,
  //   {
  //     custodyIDs,
  //     notificationType,
  //   }
  // );

  // return response.data;
}

export async function fetchPendingBids() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(`/company/${companyId}/manage-bids`);

  const data = (response.data.data as any[]).map((item) =>
    mapApiBidToModel(item)
  );

  console.log("all bids", data);

  return data;
}

export async function fetchAcceptedBids({
  nextPageToken,
}: {
  nextPageToken?: string;
}) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(`/company/${companyId}/manage-bids`);

  const filteredData = (response.data.data as any[])
    .map((item) => mapApiBidToModel(item))
    .filter((bid) => bid.status === "accepted");

  console.log("response", { data: response.data, filteredData });

  return filteredData;
}

export async function fetchRejectedBids({
  nextPageToken,
}: {
  nextPageToken?: string;
}) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(`/company/${companyId}/manage-bids`);

  const filteredData = (response.data.data as any[])
    .map((item) => mapApiBidToModel(item))
    .filter((bid) => bid.status === "rejected");

  console.log("response", { data: response.data, filteredData });

  return filteredData;
}

export async function acceptBidAPI(loadID: string, requestByID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(`/company/${companyId}/manage-bids`, {
    companyId,
    loadID,
    matchStatus: "accepted",
    shipperID: requestByID,
  });

  console.log("accept bid response chat", response.data['data']["createdChat"]);

  return response.data['data']["createdChat"];
}

export async function rejectBidAPI(loadID: string, requestByID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(`/company/${companyId}/manage-bids`, {
    companyId,
    loadID,
    matchStatus: "rejected",
    shipperID: requestByID,
  });

  console.log("reject bid response", response.data);

  return response.data;
}

export async function updateBidSettingsAPI(bidSettings: any) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/bid-settings`,
    bidSettings
  );

  return response.data;
}

export async function updateTermsAPI(netSettings: any) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/bid-payment-terms`,
    netSettings
  );

  return response.data;
}

export async function fetchBidDetails(bidID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/manage-bids/${bidID}`
  );

  return response.data ? mapApiBidToModel(response.data["data"]) : undefined;
}

export async function fetchLanes() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(`/company/${companyId}/lane`);

  const data = response.data["data"];
  const lanes = (data["lanes"] as any[]).map<Lane>((lane: any) =>
    mapApiToLaneModel(lane)
  );

  return { ...data, lanes };
}

export async function deleteLaneAPI(laneID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.delete(
    `/company/${companyId}/lane/${laneID}`
  );

  return response.data["data"];
}

export async function createLaneAPI(lane: any) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(`/company/${companyId}/lane/`, lane);

  const data = response.data["data"];
  return data?.laneID;
}

export async function updateLaneAPI(editedLane: any) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.put(
    `/company/${companyId}/lane/${editedLane.laneID}`,
    editedLane
  );

  return response.data["data"];
}

export async function fetchBidSettings() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(`/company/${companyId}/bid-settings`);

  return response.data;
}

export async function updateNotification(data: NotificationItems) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `company?type=updateCompanyNotifications&companyId=${companyId}`,
    {
      notifications: data,
    }
  );

  // the notifications are read back from the cached user company
  invalidate(CACHED.userCompany);

  console.log("assign result", response.data);
}

export async function getNotificationSettings() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);

  // same (cached) request as the startup company bootstrap
  const companies = await fetchUserCompanies(`${token}`);

  if (companies.length > 0) {
    return companies[0].notifications as any;
  }

  return companies;
}

export async function searchAirports(term: string): Promise<AirportData[]> {
  if (!term) return [];

  const response = await fetch("/data/airports.json");
  const airportsData = await response.json();

  const terms = normalizeSearchTerms(term);
  if (terms.length === 0) return [];

  const airports = Object.values(airportsData) as AirportData[];

  const filtered = airports.filter((airport) => {
    // const name = airport.name?.toLowerCase() || "";
    const country = airport.country?.toUpperCase() || "";
    const iata = airport.iata?.trim();

    // ✅ Filter for: international in name, IATA present, and in Canada or US
    // const isInternational = name.includes("international");
    const hasIata = !!iata && iata.length === 3;
    const isInCanadaOrUS = country === "CA" || country === "US";

    if (!(hasIata && isInCanadaOrUS)) {
      return false;
    }

    // ✅ Match user search terms
    const target = [
      airport.name,
      airport.city,
      airport.iata,
      airport.icao,
      airport.state,
      airport.country,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return terms.every((term) => target.includes(term.toLowerCase()));
  });

  return new Promise((resolve) => {
    setTimeout(() => resolve(filtered.slice(0, 50)), 300);
  });
}
